export default "__VITE_ASSET__ZT2fmiIl__"